var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDataRoll(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M9.48994 7.26389L9.48991 7.26385L9.48663 7.26685C9.08768 7.63334 8.55845 7.83757 8.0158 7.83293V7.83293H8.01438H3.19043C1.36681 7.69741 1.36736 5.05641 3.19041 4.92127H3.20438H3.44141L3.36122 4.69821C3.02741 3.76976 3.13382 2.9978 3.47336 2.41787C3.81524 1.83397 4.40296 1.42864 5.05787 1.25707C5.71278 1.0855 6.42289 1.15083 7.00556 1.49243C7.58424 1.83169 8.05343 2.45287 8.21496 3.42686L8.23526 3.54925L8.35833 3.56492C10.1015 3.78686 10.8107 6.11401 9.48994 7.26389Z",
    fill: "#92ABFE",
    stroke: "#92ABFE",
    strokeWidth: 0.333333
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.375 10.5C9.375 10.705 9.205 10.875 9 10.875H7C6.975 10.875 6.95499 10.875 6.92999 10.865C6.78499 11.235 6.42 11.5 6 11.5C5.58 11.5 5.21501 11.235 5.07001 10.865C5.04501 10.875 5.025 10.875 5 10.875H3C2.795 10.875 2.625 10.705 2.625 10.5C2.625 10.295 2.795 10.125 3 10.125H5C5.025 10.125 5.04501 10.125 5.07001 10.135C5.17001 9.87499 5.37499 9.67001 5.63499 9.57001C5.62499 9.54501 5.625 9.525 5.625 9.5V8H6.375V9.5C6.375 9.525 6.37501 9.54501 6.36501 9.57001C6.62501 9.67001 6.82999 9.87499 6.92999 10.135C6.95499 10.125 6.975 10.125 7 10.125H9C9.205 10.125 9.375 10.295 9.375 10.5Z",
    fill: "#92ABFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataRoll);
export default __webpack_public_path__ + "static/media/DataRoll.4405705d46d4fb4e4a103662ca45b1c6.svg";
export { ForwardRef as ReactComponent };